/* eslint-disable no-unused-vars */
import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuctionService } from './auction.service';
import { AppRouterService } from '../shared/router-service.service';
import { LoginService } from '../login/login.service';

export const auctionGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> => {
  const auctionService = inject(AuctionService);
  const appRouter = inject(AppRouterService);
  const loginService = inject(LoginService);

  return checkAuctionState(auctionService, appRouter, loginService);
};

export const auctionGuardChild: CanActivateFn = (
  _childRoute: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> => {
  const auctionService = inject(AuctionService);
  const appRouter = inject(AppRouterService);
  const loginService = inject(LoginService);

  return checkAuctionState(auctionService, appRouter, loginService);
};

async function checkAuctionState(
  auctionService: AuctionService,
  appRouter: AppRouterService,
  loginService: LoginService
) {
  await auctionService.load();

  const referer = appRouter.getParam('referer');
  if (referer === 'NO-EVENT') {
    return true;
  }

  if (!auctionService.isAnyAuctionRunning()) {
    return appRouter.getWithoutEventUrl();
  }

  const isAuctionIdPresent = !!(loginService.getAuction()?.auctionId);
  if (!isAuctionIdPresent) {
    return appRouter.getAuctionRoomUrl();
  }

  return true;
}
